<h1 mat-dialog-title>
	Rezerwacje:
	<span *ngFor="let reservation of reservations">
		<span *ngIf="reservation.status; else reservationRoute">{{ reservation?.isTourNumber }}</span>
		<ng-template #reservationRoute
			><a [routerLink]="'reservation/' + reservation.isTourNumber" target="_blank">{{
				reservation.isTourNumber
			}}</a></ng-template
		>
		&nbsp;
	</span>
</h1>
<div *ngIf="roomKind === 1">
	<div mat-dialog-content>
		<table class="table">
			<thead>
				<tr>
					<th>Imię</th>
					<th>Nazwisko</th>
					<th>Data urodzenia</th>
					<th>Kontakt</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let pos of users">
					<td>{{ pos?.firstName }}</td>
					<td>{{ pos?.lastName }}</td>
					<td>{{ pos?.birthDate }}</td>
					<td>
						<span *ngFor="let element of pos?.phone">
							{{ element }}
						</span>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
<div *ngIf="roomKind === 2">
	<div mat-dialog-content>
		<table class="table">
			<thead>
				<tr>
					<th>Imię</th>
					<th>Nazwisko</th>
					<th>Data urodzenia</th>
					<th>Kontakt</th>
					<th>Od</th>
					<th>Do</th>
					<th>Rezerwacja</th>
					<th>Status</th>
					<th>Wykwateruj</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let pos of users">
					<td>{{ pos?.firstName }}</td>
					<td>{{ pos?.lastName }}</td>
					<td>{{ pos?.birth }}</td>
					<td>
						<span *ngFor="let element of pos?.phone">
							{{ element }}
						</span>
					</td>
					<td>{{ pos?.dateFrom }}</td>
					<td>{{ pos?.dateTo }}</td>
					<td>{{ pos?.businessCaseNumber }}</td>
					<td>{{ pos?.status }}</td>
					<td>
						<button mat-button mat-dialog-close color="primary" (click)="diDoc(pos)">
							<i class="fas fa-share-square"></i> Wykwateruj
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<div *ngIf="notesIsTourLength === 1">
	<h3 mat-dialog-title>Notatki IsTour:</h3>
	<div mat-dialog-content>
		<table class="table">
			<thead>
				<tr>
					<th>Rezerwacja</th>
					<th>Notatka</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let pos of notesIsTour">
					<td>{{ pos?.number }}</td>
					<td>{{ pos?.content }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<div mat-dialog-content *ngIf="reservations[0].status">
	<h3 mat-dialog-title>Notatki Kwaterunku:</h3>
	<div *ngFor="let pos of notesAccomodationFile">
		{{ pos.number }}:
		<input matInput type="text" id="name" name="name" [(ngModel)]="pos.content" />
		<button mat-button color="primary" (click)="saveComment('current', pos)">
			<i class="fas fa-share-square"></i> Zapisz
		</button>
	</div>
	<div *ngIf="notesAccomodationFileLength === 0">
		<input matInput type="text" id="name2" name="name2" [(ngModel)]="newNotesAccomodationFile" />
		<button mat-button color="primary" (click)="saveComment('new', '')">
			<i class="fas fa-share-square"></i> Zapisz
		</button>
	</div>
</div>

<div mat-dialog-actions class="mt-3">
	<div *ngIf="roomKind === 1 && reservations[0].status">
		<div>
			<button mat-button mat-dialog-close color="primary" (click)="evictRoom(reservations)">
				<i class="fas fa-share-square"></i> Wykwateruj
			</button>
		</div>
	</div>
	<div *ngIf="roomKind === 2! && reservations[0].status">
		<button mat-button mat-dialog-close color="primary" (click)="findDoks()">
			<i class="fas fa-share-square"></i> Dokwateruj
		</button>
	</div>

	<button
		*ngIf="reservations.length && !reservations[0].status"
		mat-button
		mat-dialog-close
		color="primary"
		(click)="changeRoomBAG(data)"
	>
		<i class="fas fa-share-square"></i> Zmień pokój
	</button>

	<button
		*ngIf="reservations.length && !reservations[0].status"
		mat-button
		mat-dialog-close
		color="primary"
		(click)="removeStateFromOffer(data)"
	>
		<i class="fas fa-share-square"></i> Wykwateruj
	</button>

	<div class="spacer"></div>
	<button mat-button mat-dialog-close>Zamknij</button>
</div>
